var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscription-switch"},[_c('AutoScroll'),_c('PageBlock',{attrs:{"title":_vm.$t('swithcing', { to: _vm.$t('tariffs.' + _vm.to.slug) })}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('warning.' + _vm.fromToType, {
        period: _vm.$t('periods.' + _vm.to.period),
        expire: _vm.localizeNext,
        'less-more': _vm.lessMore,
      }))}})]),_c('TariffSwitchAction',{attrs:{"from":_vm.from,"to":_vm.to}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }